import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoashtavinayakdarshan() {



  const cardData = {
"keyword": "Pune to Ashtavinayak Darshan Tempo Traveller",

"headingDescription":
  "Aaradhya Travels offers comfortable Pune to Ashtavinayak Darshan Tempo Traveller services for family pilgrimages, group tours, senior citizen trips, and spiritual journeys. Our fleet includes 9, 12, 14, 17, and 20-seater tempo travellers with air-conditioning, pushback seats, spacious interiors, luggage space, charging points, and experienced drivers familiar with Ashtavinayak temple routes across Maharashtra. We ensure safe, smooth, and punctual travel with doorstep pickup and drop services from Pune for a complete Ashtavinayak darshan experience.",

"topPlaces": [
  {
    "title": "Morgaon Mayureshwar Temple",
    "description":
      " is the first temple in the Ashtavinayak circuit and is dedicated to Lord Ganesha as Mayureshwar."
  },
  {
    "title": "Siddhivinayak Temple Siddhatek",
    "description":
      " is a powerful Ganpati temple known for fulfilling wishes and is part of the Ashtavinayak pilgrimage."
  },
  {
    "title": "Ballaleshwar Temple Pali",
    "description":
      " is the only Ashtavinayak temple named after a devotee of Lord Ganesha."
  },
  {
    "title": "Varadvinayak Temple Mahad",
    "description":
      " is a peaceful temple where the idol is believed to be self-manifested and grants blessings."
  },
  {
    "title": "Chintamani Temple Theur",
    "description":
      " is a major Ganpati temple known for removing worries and bringing peace."
  },
  {
    "title": "Girijatmaj Temple Lenyadri",
    "description":
      " is a cave temple dedicated to Lord Ganesha located in the Sahyadri hills."
  },
  {
    "title": "Vighneshwar Temple Ozar",
    "description":
      " is a famous Ashtavinayak temple known for its divine idol and spiritual importance."
  },
  {
    "title": "Mahaganpati Temple Ranjangaon",
    "description":
      " is a powerful Ganpati temple representing the final stop of the Ashtavinayak circuit."
  },
  {
    "title": "Sahyadri Hills Route",
    "description":
      " offers scenic drives and natural beauty along the Ashtavinayak pilgrimage route."
  },
  {
    "title": "Bhima River Region",
    "description":
      " flows near several Ashtavinayak temples and is part of the spiritual landscape of the region."
  }
],



services: [
  {
    name: "Pune to Ashtavinayak Tempo Traveller",
    description: "Pune to Ashtavinayak tempo traveller service provides comfortable transportation for pilgrimage journeys, family vacations, group tours, and temple darshan travel requirements. Spacious seating and smooth highway travel ensure pleasant journeys suitable for long-distance religious travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient Ashtavinayak tempo traveller reservations."
  },
  {
    name: "Ashtavinayak Darshan Tour from Pune",
    description: "Ashtavinayak darshan tour from Pune service offers dependable transportation for visiting all eight Ganpati temples comfortably with family and group travelers. Spacious seating and smooth travel ensure pleasant journeys suitable for pilgrimage tours and spiritual travel requirements. Professional drivers ensure safe transportation and punctual pickup services throughout the darshan route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Ashtavinayak darshan tour reservations."
  },
  {
    name: "Pune Ashtavinayak Pilgrimage Bus",
    description: "Pune Ashtavinayak pilgrimage bus service provides spacious transportation for temple visits, spiritual journeys, family tours, and group pilgrimage travel. Comfortable seating and luggage capacity ensure smooth journeys suitable for pilgrims and religious passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient pilgrimage bus reservations."
  },
  {
    name: "8 Ganpati Temple Tour Pune",
    description: "8 Ganpati temple tour Pune service offers reliable transportation for complete Ashtavinayak darshan journeys, family pilgrimages, and religious group tours. Spacious seating and comfortable interiors ensure pleasant travel experiences suitable for local and outstation spiritual journeys. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient Ganpati temple tour reservations."
  },
  {
    name: "Pune to Morgaon Ganpati Traveller",
    description: "Pune to Morgaon Ganpati traveller service provides dependable transportation for pilgrimage journeys, temple visits, and family spiritual travel. Spacious seating and smooth highway travel ensure comfortable journeys suitable for local and outstation darshan trips. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Morgaon Ganpati traveller reservations."
  },
  {
    name: "Pune to Siddhatek Ganpati Traveller",
    description: "Pune to Siddhatek Ganpati traveller service offers comfortable transportation for pilgrimage tours, family travel, and temple darshan journeys. Spacious interiors and luggage capacity ensure pleasant journeys suitable for religious passenger groups and tourists. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Siddhatek Ganpati traveller reservations."
  },
  {
    name: "Pune to Theur Chintamani Traveller",
    description: "Pune to Theur Chintamani traveller service provides reliable transportation for temple visits, pilgrimage tours, and family spiritual journeys. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and long-distance religious travel. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient Theur Chintamani traveller reservations."
  },
  {
    name: "Pune to Ranjangaon Ganpati Traveller",
    description: "Pune to Ranjangaon Ganpati traveller service offers dependable transportation for Ganpati darshan, pilgrimage tours, and family religious journeys. Spacious seating and smooth highway travel ensure comfortable journeys suitable for temple tours and group travel. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Ranjangaon Ganpati traveller reservations."
  },
  {
    name: "Pune to Ozar Vighnahar Traveller",
    description: "Pune to Ozar Vighnahar traveller service provides spacious transportation for spiritual journeys, family pilgrimages, and temple tours. Comfortable seating and luggage capacity ensure pleasant journeys suitable for local and outstation religious travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Ozar Vighnahar traveller reservations."
  },
  {
    name: "Pune to Lenyadri Ganpati Traveller",
    description: "Pune to Lenyadri Ganpati traveller service offers reliable transportation for pilgrimage journeys, hill temple visits, family outings, and religious group travel. Spacious seating and smooth highway travel ensure comfortable journeys suitable for spiritual travel requirements. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Lenyadri Ganpati traveller reservations."
  },
  {
    name: "Pune to Mahad Varadvinayak Traveller",
    description: "Pune to Mahad Varadvinayak traveller service provides dependable transportation for Ganpati darshan, pilgrimage journeys, and family temple tours. Spacious interiors and luggage capacity ensure pleasant journeys suitable for local and outstation travel requirements. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Mahad Varadvinayak traveller reservations."
  },
  {
    name: "Pune to Pali Ballaleshwar Traveller",
    description: "Pune to Pali Ballaleshwar traveller service offers premium transportation for temple visits, pilgrimage journeys, family vacations, and spiritual travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for religious group travel and tourist journeys. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient Pali Ballaleshwar traveller reservations."
  },
  {
    name: "Ashtavinayak Group Tour Pune",
    description: "Ashtavinayak group tour Pune service provides spacious transportation for pilgrimage groups, family tours, educational journeys, and spiritual travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium and large passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, schools, and residential areas across Pune. Flexible booking options allow convenient Ashtavinayak group tour reservations."
  },
  {
    name: "Ashtavinayak AC Tempo Traveller Pune",
    description: "Ashtavinayak AC tempo traveller Pune service offers premium air-conditioned transportation for pilgrimage tours, family journeys, and religious group travel. Spacious seating and cooling systems ensure comfortable journeys suitable for all weather conditions. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient AC tempo traveller reservations."
  },
  {
    name: "Ashtavinayak Luxury Traveller Pune",
    description: "Ashtavinayak luxury traveller Pune service provides premium transportation with spacious interiors and modern seating for pilgrimage tours, family vacations, and spiritual travel. Smooth highway journeys ensure pleasant travel suitable for tourist groups and premium passengers. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient luxury traveller reservations."
  },
  {
    name: "Ashtavinayak 17 Seater Traveller Pune",
    description: "Ashtavinayak 17 seater traveller Pune service offers spacious transportation for pilgrimage groups, family vacations, and temple darshan journeys. Comfortable seating and luggage space ensure pleasant journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient 17 seater traveller reservations."
  },
  {
    name: "Ashtavinayak 20 Seater Traveller Pune",
    description: "Ashtavinayak 20 seater traveller Pune service provides dependable transportation for religious tours, educational journeys, family trips, and group pilgrimage travel. Spacious seating and luggage capacity ensure smooth journeys suitable for larger passenger groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, temples, and residential areas across Pune. Flexible booking options allow convenient 20 seater traveller reservations."
  },
  {
    name: "Ashtavinayak Family Tour Pune",
    description: "Ashtavinayak family tour Pune service offers reliable transportation for spiritual journeys, holiday vacations, temple visits, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient family tour reservations."
  },
  {
    name: "Ashtavinayak Weekend Tour Pune",
    description: "Ashtavinayak weekend tour Pune service provides comfortable transportation for short holiday trips, pilgrimage journeys, family vacations, and spiritual group travel. Smooth highway travel and spacious seating ensure pleasant journeys suitable for weekend travel requirements. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient weekend tour reservations."
  },
  {
    name: "Ashtavinayak Private Booking Pune",
    description: "Ashtavinayak private booking Pune service offers exclusive transportation for family vacations, pilgrimage journeys, sightseeing tours, and private group travel. Spacious seating and premium interiors ensure comfortable journeys suitable for private passenger groups. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient private booking reservations."
  },
  {
    name: "Ashtavinayak Darshan Package Pune",
    description: "Ashtavinayak darshan package Pune service provides organized transportation for complete temple tours, pilgrimage journeys, and spiritual family travel. Comfortable seating and smooth highway journeys ensure pleasant travel suitable for pilgrims and tourist groups. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the darshan itinerary. Pickup services are available from homes, hotels, temples, and residential areas across Pune. Flexible booking options allow convenient darshan package reservations."
  },
  {
    name: "Pune Religious Tour Traveller",
    description: "Pune religious tour traveller service offers dependable transportation for temple visits, pilgrimage journeys, spiritual tours, and family travel requirements. Spacious seating and luggage capacity ensure comfortable journeys suitable for local and outstation religious travel. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient religious tour traveller reservations."
  },
  {
    name: "Pune Temple Tour Bus Hire",
    description: "Pune temple tour bus hire service provides spacious transportation for spiritual journeys, pilgrimage tours, educational trips, and religious group travel. Comfortable seating and smooth highway travel ensure pleasant journeys suitable for medium and large passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, schools, temples, and residential areas across Pune. Flexible booking options allow convenient temple tour bus hire reservations."
  },
  {
    name: "Pune Pilgrimage Travel Service",
    description: "Pune pilgrimage travel service offers reliable transportation for spiritual tours, temple visits, Jyotirlinga darshan, and religious family journeys. Spacious seating and premium interiors ensure smooth journeys suitable for local and long-distance pilgrimage travel. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient pilgrimage travel service reservations."
  },
  {
    name: "Ashtavinayak Round Trip Bus Pune",
    description: "Ashtavinayak round trip bus Pune service provides complete return transportation for pilgrimage tours, family vacations, temple visits, and group travel requirements. Spacious seating and luggage capacity ensure comfortable travel experiences suitable for long-distance round trips. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, temples, hotels, and residential areas across Pune. Flexible booking options allow convenient round trip bus reservations."
  }
],

tableData: [
  ["Pune to Ashtavinayak Tempo Traveller", "Ashtavinayak Darshan Tour from Pune"],
  ["Pune Ashtavinayak Pilgrimage Bus", "8 Ganpati Temple Tour Pune"],
  ["Pune to Morgaon Ganpati Traveller", "Pune to Siddhatek Ganpati Traveller"],
  ["Pune to Theur Chintamani Traveller", "Pune to Ranjangaon Ganpati Traveller"],
  ["Pune to Ozar Vighnahar Traveller", "Pune to Lenyadri Ganpati Traveller"],
  ["Pune to Mahad Varadvinayak Traveller", "Pune to Pali Ballaleshwar Traveller"],
  ["Ashtavinayak Group Tour Pune", "Ashtavinayak AC Tempo Traveller Pune"],
  ["Ashtavinayak Luxury Traveller Pune", "Ashtavinayak 17 Seater Traveller Pune"],
  ["Ashtavinayak 20 Seater Traveller Pune", "Ashtavinayak Family Tour Pune"],
  ["Ashtavinayak Weekend Tour Pune", "Ashtavinayak Private Booking Pune"],
  ["Ashtavinayak Darshan Package Pune", "Pune Religious Tour Traveller"],
  ["Pune Temple Tour Bus Hire", "Pune Pilgrimage Travel Service"],
  ["Ashtavinayak Round Trip Bus Pune", "Pune to Ashtavinayak Tempo Traveller"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ashtavinayak Darshan Tempo Traveller",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Ashtavinayak Darshan Tempo Traveller rental service with comfortable vehicles, professional drivers, and smooth travel arrangements for family trips, pilgrimage tours, and group travel."
      },
      {
        WhyChooseheading: "Affordable Ashtavinayak Tempo Traveller Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Ashtavinayak Darshan Tempo Traveller packages with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Booking Service",
        WhyChoosedescription: "Our Pune to Ashtavinayak Darshan Tempo Traveller service operates 24 hours for Ganpati temple tours, family vacations, religious journeys, group outings, and comfortable pilgrimage travel."
      },
      {
        WhyChooseheading: "Comfortable AC Tempo Travellers for Darshan Tours",
        WhyChoosedescription: "All Tempo Travellers provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for safe and comfortable Ashtavinayak Darshan group travel experiences."
      },
      {
        WhyChooseheading: "Customized Ashtavinayak Tour Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized Ashtavinayak Darshan travel packages covering all eight Ganpati temples with one-day, two-day, and multi-day pilgrimage tour options."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Tempo Traveller Options",
        WhyChoosedescription: "Customers can choose from 13 seater, 17 seater, 20 seater, 26 seater, and luxury Tempo Travellers suitable for family groups, pilgrims, tourists, and corporate travel."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Pimpri Chinchwad, Pune Airport, railway stations, hotels, and all major Pune locations."
      },
      {
        WhyChooseheading: "Experienced Drivers for Safe Pilgrimage Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth highway journeys, and timely travel for Pune to Ashtavinayak Darshan pilgrimage tours and group transportation."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ashtavinayak Darshan Tempo Traveller service?", answer: "Pune to Ashtavinayak Darshan Tempo Traveller service provides comfortable group transportation for visiting all eight Ashtavinayak Ganpati temples in Maharashtra." },
    { question: "Is Ashtavinayak Tempo Traveller booking available 24 hours?", answer: "Yes, Aaradhya Travels provides 24/7 Pune to Ashtavinayak Darshan Tempo Traveller rental service." },
    { question: "Which Tempo Traveller seating options are available?", answer: "Aaradhya Travels offers 13 seater, 17 seater, 20 seater, 26 seater, and luxury Tempo Travellers for Ashtavinayak pilgrimage travel." },
    { question: "Can I book Tempo Traveller for family pilgrimage tours?", answer: "Yes, customers can book Tempo Travellers for family trips, religious tours, group travel, and Ganpati Darshan packages." },
    { question: "Are all Tempo Travellers air-conditioned?", answer: "Yes, all Tempo Travellers are fully air-conditioned and maintained for comfortable long-distance pilgrimage travel." },
    { question: "Do you provide one-day and multi-day Ashtavinayak tour packages?", answer: "Yes, Aaradhya Travels provides one-day, two-day, and customized Ashtavinayak Darshan travel packages." },
    { question: "Can I book Pune to Ashtavinayak Tempo Traveller online?", answer: "Yes, customers can easily book Pune to Ashtavinayak Darshan Tempo Traveller service online or through phone booking." },
    { question: "Do you provide pickup from Pune Airport and railway station?", answer: "Yes, Aaradhya Travels provides airport, railway station, hotel, and home pickup service across Pune." },
    { question: "Are Tempo Traveller rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Ashtavinayak Tempo Traveller service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, Ganesh festivals, and pilgrimage travel seasons." }
  ];

 const testimonials = [
  {
    id: 1,
    name: "Mr. Milind Joshi",
    feedback:
      "Our Pune to Ashtavinayak Darshan trip with Aaradhya Travels in a Tempo Traveller was very comfortable and well planned. The journey felt peaceful, and all temple visits were managed without any rush or confusion.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rekha Deshpande",
    feedback:
      "Aaradhya Travels made our Pune to Ashtavinayak Darshan journey smooth with a clean and spacious Tempo Traveller. The ride was comfortable for the entire family, and the trip was well organized from start to end.",
    rating: 5
  }
];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];
















  return (
    <div>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/94.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoashtavinayakdarshan ;